;(function() {
  'use strict'

  checkBrowser.$inject = ["glDialog"];
  var dependencies = []

  angular.module('core.unsupportedBrowser', dependencies).run(checkBrowser)

  /* @ngInject */
  function checkBrowser(glDialog) {
    var MIN_IE_VERSION = 10
    var IEVersion = getIEVersion()

    // display dialog if browser is unsupported
    if (IEVersion && IEVersion < MIN_IE_VERSION) {
      glDialog.show({
        templateUrl: 'unsupported-browser.template.html',
        controller: function() {},
      })
    }

    // Returns the version of IE being used, or false if not IE
    function getIEVersion() {
      var agent = navigator.userAgent.toLowerCase()
      var version =
        agent.indexOf('msie') !== -1 ? parseInt(agent.split('msie')[1]) : false
      return version
    }
  }
})()
